import SecondaryFooter from "./SecondaryFooter";
export default SecondaryFooter;
